/**
 * 양식 문서의 종류(V574 · DOC-136) — 서버 SafeJournal.DOC_TYPES 와 같은 목록 · 이름이다. 주소는 현장 화면의 세부 메뉴 키.
 * 새 양식은 여기 한 줄 + 서버 DOC_TYPES 한 줄 + 칸 정의(registry 의 묶음 파일) 하나.
 */
export const DOC_TYPES = {
  POLICY: { label: '안전보건 목표 및 방침', path: '/policy' },
  ORG: { label: '안전보건조직', path: '/org' },
  COST: { label: '산업안전보건관리비', path: '/cost' },
  RISK_PLAN: { label: '위험성평가 계획서', path: '/risk-plan' },
  RISK_MEETING: { label: '위험성평가 회의록', path: '/risk-meeting' },
  HAZARD_SURVEY: { label: '위험요인 정보조사표', path: '/hazard-survey' },
  DAILY_CHECK: { label: '일일안전보건점검', path: '/daily-check' },
  WEEKLY_CHECK: { label: '주간안전보건점검', path: '/weekly-check' },
  WORK_PLAN: { label: '작업계획서', path: '/work-plan' },
  PERMIT: { label: '작업허가서', path: '/permit' },
  COUNCIL: { label: '노사협의체 회의록', path: '/council' },
  SCENARIO: { label: '비상 시나리오 및 대응 절차', path: '/scenario' },
  DRILL: { label: '비상훈련 결과', path: '/drill' },
  ACCIDENT: { label: '사고보고서', path: '/accident' },
  HEAT_CHECK: { label: '온열질환 일일 점검', path: '/heat-check' },
  HEAT_ACCIDENT: { label: '온열질환 사고보고', path: '/heat-accident' },
} as const;

export type DocType = keyof typeof DOC_TYPES;

export function isDocType(type: string | null | undefined): type is DocType {
  return !!type && Object.prototype.hasOwnProperty.call(DOC_TYPES, type);
}
